/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 */
import { api } from '../../../config/api';

import type { ActivateAgentApiArg, AgentToggleData } from '../types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    activateAgent: build.mutation<AgentToggleData, ActivateAgentApiArg>({
      query: (queryArg) => ({
        body: undefined,
        method: 'POST',
        url: `/v1/conversations/${queryArg.conversationId}/activate`,
      }),
    }),
  }),
  overrideExisting: true,
});

export { injectedRtkApi as activateAgentApi };
export const { useActivateAgentMutation } = injectedRtkApi;
